{
	"description": "Nuestro equipo ya ha sido notificado del error. Vuelva a cargar la página e inténtelo de nuevo.",
	"descriptionWithError": "Si el problema es recurrente, informe a nuestro equipo el código anterior.",
	"subtitle": "Código de error",
	"title": "Algo salió mal"
}
